import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import TimelineIcon from '@mui/icons-material/Timeline'
import {
  Backdrop,
  Box,
  Card,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import { differenceInSeconds } from 'date-fns'
import { toFarsiDigits } from 'farsi-digits'
import _ from 'lodash'
import { useSnackbar } from 'notistack'
import React, { useEffect, useRef, useState } from 'react'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import { useTranslation } from 'react-i18next'
import { DateObject } from 'react-multi-date-picker'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import sf from 'seconds-formater'

import * as routes from '../../config/constants'
import Button from '../../shared/Button'
import CardEngineInfo from '../../shared/CardEngineInfo'
import {
  getError,
  getLastReObd,
  getLoading,
  getMessage,
  getObdLast,
  getRepairingObd,
  getTopObdsChart,
  repairingObdReset,
  resetLastReObd,
  setError,
  setMessage,
  setOffRepairing,
  setRepairingObd,
} from '../../store/devices'
import { getDeviceId, resetDateAndDeviceId, setDateAndDeviceId, getDate } from '../../store/ui'
const InfoEngineScreen = () => {
  const { t } = useTranslation()
  const message = useSelector(getMessage)
  const repairingObd = useSelector(getRepairingObd)
  const location = useLocation()
  const dispatch = useDispatch<Dispatch<any>>()
  const [open, setOpen] = React.useState(false)
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const { id } = useParams()
  const lastObd = useSelector(getObdLast)

  const error = useSelector(getError)
  const handleClick = () => {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    navigate(`/${routes.REPORT_ENGINE}/${id}`, { state: { id: location.state.location.state.id } })
  }
  const handleClose = () => {
    setOpen(false)
  }
  const handleClickDiag = () => {
    setOpen(true)
  }

  useEffect(() => {
    if (message === undefined) return
    enqueueSnackbar(message, { variant: 'success' })
    dispatch(setMessage(undefined))
    // navigate(`/${routes.CARS}`)
  }, [message])
  useEffect(() => {
    if (error === undefined) return
    enqueueSnackbar(error, { variant: 'error' })

    dispatch(setError(undefined))
  }, [error])
  useEffect(() => {
    if (repairingObd === undefined) return
    if (repairingObd.item1 !== '') {
      dispatch(
        setMessage(
          'به حالت دیاگ تعمیرگاهی تغییر یافت در این حالت اطلاعات به صورت لحظه ای بروز رسانی می شود',
        ),
      )
      const refreshIntervalId = setInterval(() => {
        dispatch(getLastReObd(location.state.location.state.id))
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    } else {
      dispatch(setError('خودرو در حال حرکت می باشد'))
    }
    // navigate(`/${routes.CARS}`)
  }, [repairingObd])

  useEffect(() => {
    dispatch(getLastReObd(location.state.location.state.id))
  }, [])
  useEffect(() => {
    return () => {
      dispatch(resetLastReObd)
    }
  }, [])
  // تابع تبدیل تاریخ شمسی به میلادی
  const shamsi = (time: string) => {
    if (time === undefined) return
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.format('YYYY/MM/DD HH:mm:ss')
  }
  // توایع نمایش اطلاعات موتور

  const handleGeneral = (property: string, title: string) => {
    dispatch(
      getTopObdsChart({
        deviceId: location.state.location.state.id,
        top: 10,
        oBDProperty: property,
      }),
    )
    navigate(`/${routes.CHART_INFO_ENGINE}`, {
      state: {
        location: location.state.location.state.id,
        oBDProperty: property,
        title: title,
      },
    })
  }

  const handleToggle1 = () => {
    // setToggle(!toggle)
    dispatch(repairingObdReset)
    dispatch(setDateAndDeviceId({ date: Date.now(), deviceId: id }))
    setCount(0)
    dispatch(setOffRepairing({ imei: id, interval: 0 }))
    // clearInterval(counterRef.current)
    // dispatch(resetLastObd)
    // setOn(!on);
  }

  // const count = useSelector(getCount)
  const date = useSelector(getDate)
  const deviceId = useSelector(getDeviceId)
  const counterRef = useRef<any>()
  const [count, setCount] = useState<number | undefined>(undefined)

  const handleDiag = () => {
    dispatch(setRepairingObd({ imei: id }))

    setOpen(false)
    // if (repairingObd.item1 !== '') {
    dispatch(setDateAndDeviceId({ date: Date.now(), deviceId: id }))
    // }
  }

  useEffect(() => {
    if (count === undefined) return
    if (count === 0 && id === deviceId) {
      clearInterval(counterRef.current)
      dispatch(resetDateAndDeviceId())
    }
  }, [count])

  useEffect(() => {
    if (date === undefined) return

    const diff = 100 - differenceInSeconds(Date.now(), date)
    setCount(diff)
  }, [date])

  const tick = () => setCount((prev: any) => prev - 1)

  useEffect(() => {
    if (date === undefined || id !== deviceId) {
      setCount(0)
      return
    }
    counterRef.current = setInterval(() => {
      tick()
    }, 1000)

    return () => {
      clearInterval(counterRef.current)
    }
  }, [date, deviceId])

  return (
    <Container fixed maxWidth='sm'>
      <Box display='grid' gridTemplateColumns='auto auto' sx={{ mt: 2, mb: 2, direction: 'ltr' }}>
        <ArrowBackRoundedIcon
          onClick={() => navigate(-1)}
          sx={{
            backgroundColor: 'red',
            borderRadius: '50%',
            color: '#fff',
            cursor: 'pointer',
          }}
        />
        <img alt='Logo' src='/images/TinyLogo.png' />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
      >
        {lastObd.length !== 0 ? (
          <Box
            display='flex'
            justifyContent='space-between'
            sx={{ mt: 2, mb: 2, direction: 'ltr' }}
          >
            <Button onClick={handleClick} sx={{ p: 1 }}>
              {t('screens.InfoEngineScreen.report')}
            </Button>

            <Typography sx={{ fontSize: 14, textAlign: 'center' }}>
              {t('screens.InfoEngineScreen.last_update')}:{shamsi(lastObd?.creationDate)}
            </Typography>

            {count === undefined || count === 0 ? (
              <Button onClick={handleClickDiag} sx={{ p: 1 }}>
                {t('screens.InfoEngineScreen.repair_diag')}
              </Button>
            ) : (
              <Button
                onClick={handleToggle1}
                sx={{
                  width: '150px',
                  '& .MuiButton-startIcon': {
                    marginRight: '45px',
                    marginLeft: '5px',
                  },
                  '& .MuiButton-startIcon>*:nth-of-type(1)': {
                    fontSize: '20px',
                  },
                }}
                variant='contained'
              >
                {sf.convert(count).format('MM:SS')}
                {/* {count} */}
              </Button>
            )}
          </Box>
        ) : (
          <Card sx={{ p: 1, display: 'flex', justifyContent: 'center' }}>
            <Typography>{t('screens.InfoEngineScreen.no_info')}</Typography>
          </Card>
        )}
        {/* <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
          <CircularProgress color='inherit' />
        </Backdrop> */}
        <div dir='rtl'>
          {lastObd?.ODO !== undefined &&
            (lastObd?.ODO?.FS!== 0.0 ||
              lastObd?.ODO?.GA!== 0.0 ||
              lastObd?.ODO?.GE!== 0.0 ||
              lastObd?.ODO?.MI!== 0.0 ||
              lastObd?.ODO?.DT!== 0.0 ||
              lastObd?.ODO?.PE !== 0.0) && (
              <CardEngineInfo title='کیلومتر پیموده شده'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.ODO?.DT !== undefined &&
                    lastObd?.ODO?.DT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>از زمان پاک شده خطا</Typography>
                          <Typography>{lastObd?.ODO?.DT}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('ODO.DTCClear', 'از زمان پاک شده خطا')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.ODO?.FS !== undefined &&
                    lastObd?.ODO?.FS!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>با حسگر سرعت خراب</Typography>
                          <Typography>{lastObd?.ODO?.FS}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('ODO.FaultSpeed', 'با حسگر سرعت خراب')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.ODO?.GA !== undefined && lastObd?.ODO?.GA!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>گاز</Typography>
                        <Typography>{lastObd?.ODO?.GA}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('ODO.Gas', 'گاز')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                    </Box>
                  )}
                  {lastObd?.ODO?.GE !== undefined && lastObd?.ODO?.GE!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>کلی</Typography>
                        <Typography>{lastObd?.ODO?.GE}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('ODO.General', 'کلی')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                    </Box>
                  )}
                  {lastObd?.ODO?.MI !== undefined && lastObd?.ODO?.MI!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>با چراغ چک روشن</Typography>
                        <Typography>{lastObd?.ODO?.MI}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('ODO.MILON', 'با چراغ چک روشن')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                    </Box>
                  )}
                  {lastObd?.ODO?.PE !== undefined && lastObd?.ODO?.PE!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>بنزین</Typography>
                        <Typography>{lastObd?.ODO?.PE}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('ODO.Petrol', 'بنزین')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.BAT !== undefined &&
            (lastObd?.BAT?.CH!== 0.0 ||
              lastObd?.BAT?.CU!== 0.0 ||
              lastObd?.BAT?.TE!== 0.0 ||
              lastObd?.BAT?.VB!== 0.0 ||
              lastObd?.BAT?.VA !== 0.0) && (
              <CardEngineInfo title='باتری'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.BAT?.CH !== undefined && lastObd?.BAT?.CH!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>شارژ باتری</Typography>
                        <Typography>{lastObd?.BAT?.CH}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('BAT.Charge', 'باطری شارژ باطری')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.BAT?.CU !== undefined && lastObd?.BAT?.CU!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>جریان باتری</Typography>
                        <Typography>{lastObd?.BAT?.CU}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('BAT.Current', 'باطری جریان باطری')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.BAT?.TE !== undefined && lastObd?.BAT?.TE!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>دمای باتری</Typography>
                        <Typography>{lastObd?.BAT?.TE}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('BAT.Temp', 'باطری دمای باطری')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                    </Box>
                  )}
                  {lastObd?.BAT?.VB !== undefined && lastObd?.BAT?.VB!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ باتری</Typography>
                        <Typography>{lastObd?.BAT?.VB}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('BAT.VoltBattery', 'باطری ولتاژ باطری')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.BAT?.VA !== undefined && lastObd?.BAT?.VA!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ دینام</Typography>
                        <Typography>{lastObd?.BAT?.VA}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('BAT.VoltAlternator', 'باطری ولتاژ دینام')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.CAN !== undefined &&
            (lastObd?.CAN?.AN!== 0.0 ||
              lastObd?.CAN?.LE !== 0.0 ) && (
              <CardEngineInfo title='کنیستر'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.CAN?.AN !== undefined &&
                    lastObd?.CAN?.AN!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>میزان باز بودن شیر کنیستر</Typography>
                          <Typography>{lastObd?.CAN?.AN}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Canister.Angle', 'میزان باز بودن شیر کنیستر')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.CAN?.LE !== undefined &&
                    lastObd?.CAN?.LE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>میزان پرشدگی کنیستر</Typography>
                          <Typography>{lastObd?.CAN?.LE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Canister.Level', 'میزان پرشدگی کنیستر')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.COIL !== undefined &&
            (lastObd?.COIL?.C1!== 0.0 ||
              lastObd?.COIL?.C2!== 0.0 ||
              lastObd?.COIL?.C3!== 0.0 ||
              lastObd?.COIL?.C4!== 0.0 ||
              lastObd?.COIL?.AVG !== 0.0) && (
              <CardEngineInfo title='کویل'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.COIL?.C1 !== undefined &&
                    lastObd?.COIL?.C1!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان شارژ کویل 1</Typography>
                          <Typography>{lastObd?.COIL?.C1}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Coil.Time1', 'زمان شارژ کویل 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COIL?.C2 !== undefined &&
                    lastObd?.COIL?.C2!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان شارژ کویل 2 </Typography>
                          <Typography>{lastObd?.COIL?.C2}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Coil.Time2', 'زمان شارژ کویل 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COIL?.C3 !== undefined &&
                    lastObd?.COIL?.C3!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان شارژ کویل 3 </Typography>
                          <Typography>{lastObd?.COIL?.C3}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Coil.Time3', 'زمان شارژ کویل 3')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COIL?.C4 !== undefined &&
                    lastObd?.COIL?.C4!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان شارژ کویل 4 </Typography>
                          <Typography>{lastObd?.COIL?.C4}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Coil.Time4', 'زمان شارژ کویل 4')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COIL?.AVG !== undefined &&
                    lastObd?.COIL?.AVG!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان شارژ کویل عمومی</Typography>
                          <Typography>{lastObd?.COIL?.AVG}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Coil.TimeAVG', 'زمان شارژ کویل عمومی')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.CMP !== undefined &&
            (lastObd?.CMP?.PO!== 0.0 || lastObd?.CMP?.IS !== 0.0) && (
              <CardEngineInfo title=' زوایه میل بادامک'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.CMP?.PO !== undefined &&
                    lastObd?.CMP?.PO!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>موقعیت میل بادامک</Typography>
                          <Typography>{lastObd?.CMP?.PO}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('CMP.Position', 'موقعیت میل بادامک')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.CMP?.IS !== undefined &&
                    lastObd?.CMP?.IS!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>نقطه تنظیم میل بادامک</Typography>
                          <Typography>{lastObd?.CMP?.IS}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('CMP.SetPoint', 'نقطه تنظیم میل بادامک')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.CTS !== undefined &&
            (lastObd?.CTS?.TE!== 0.0 || lastObd?.CTS?.VO !== 0.0) && (
              <CardEngineInfo title=' دمای آب رادیاتور'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.CTS?.TE !== undefined && lastObd?.CTS?.TE!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>دما</Typography>
                        <Typography>{lastObd?.CTS?.TE}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('CTS.Temp', 'حسگر دمای آب رادیاتور، دما')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                    </Box>
                  )}
                  {lastObd?.CTS?.VO !== undefined && lastObd?.CTS?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ</Typography>
                        <Typography>{lastObd?.CTS?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('CTS.Volt', 'حسگر دمای آب رادیاتور، ولتاژ')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.EGR !== undefined && lastObd?.EGR?.AN!== 0.0 && (
            <CardEngineInfo title='شیر برقی'>
              <Box display='flex' flexDirection='column'>
                {lastObd?.EGR?.AN !== undefined && lastObd?.EGR?.AN!== 0.0 && (
                  <Box display='flex' justifyContent='space-between'>
                    <Box
                      alignItems='center'
                      display='flex'
                      justifyContent='space-between'
                      width='200px'
                    >
                      <Typography>مقدار باز بودن شیر برقی </Typography>
                      <Typography>{lastObd?.EGR?.AN}</Typography>
                    </Box>
                    <IconButton onClick={() => handleGeneral('EGR.Angle', 'مقدار باز بودن شیر برقی')}>
                      <TimelineIcon
                        sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                      />
                      </IconButton>
                  </Box>
                )}
              </Box>
            </CardEngineInfo>
          )}
          {lastObd?.ENGINE !== undefined &&
            (lastObd?.ENGINE?.TE!== 0.0 ||
              lastObd?.ENGINE?.RT!== 0.0 ||
              lastObd?.ENGINE?.EL !== 0.0) && (
              <CardEngineInfo title='موتور'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.ENGINE?.EL !== undefined && lastObd?.ENGINE?.EL!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>بار موتور</Typography>
                        <Typography>{lastObd?.ENGINE?.EL}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('Engine.Load', 'بار موتور')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                    </Box>
                  )}
                  {lastObd?.ENGINE?.RT !== undefined &&
                    lastObd?.ENGINE?.RT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان روشن بودن موتور</Typography>
                          <Typography>{lastObd?.ENGINE?.RT}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('زمان روشن بودن موتور', 'Engine.Runtime')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.ENGINE?.TE !== undefined && lastObd?.ENGINE?.TE!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>دمای موتور</Typography>
                        <Typography>{lastObd?.ENGINE?.TE}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('دمای موتور', 'Engine.Temp')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.FAN !== undefined &&
            (lastObd?.FAN?.S1!== 0.0 ||
              lastObd?.FAN?.S2!== 0.0 ||
              lastObd?.FAN?.VO !== 0.0) && (
              <CardEngineInfo title='فن'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.FAN?.S1 !== undefined &&
                    lastObd?.FAN?.S1!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>سرعت فن دور تند</Typography>
                          <Typography>{lastObd?.FAN?.S1}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('سرعت فن دور تند', 'Fan.SpeedFast')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.FAN?.S2 !== undefined &&
                    lastObd?.FAN?.S2!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>سرعت فن دور کند</Typography>
                          <Typography>{lastObd?.FAN?.S2}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('سرعت فن دور کند', 'Fan.SpeedLow')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.FAN?.VO !== undefined && lastObd?.FAN?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ فن</Typography>
                        <Typography>{lastObd?.FAN?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('ولتاژ فن', 'Fan.Volt')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.FLS !== undefined &&
            (lastObd?.FLS?.LE!== 0.0 || lastObd?.FLS?.VO !== 0.0) && (
              <CardEngineInfo title='حسگر سطح سوخت'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.FLS?.LE !== undefined && lastObd?.FLS?.LE!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>سطح سوخت باک</Typography>
                        <Typography>{lastObd?.FLS?.LE}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('FLS.Level', 'سطح سوخت باک')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.FLS?.VO !== undefined && lastObd?.FLS?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ حسگر سطح سوخت باک</Typography>
                        <Typography>{lastObd?.FLS?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('FLS.Volt', 'ولتاژ حسگر سطح سوخت باک')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.GEAR !== undefined && lastObd?.GEAR?.NUM!== 0.0 && (
            <CardEngineInfo title='جعبه دنده'>
              <Box display='flex' flexDirection='column'>
                {lastObd?.GEAR?.NUM !== undefined &&
                  lastObd?.GEAR?.NUM!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>شماره دنده</Typography>
                        <Typography>{lastObd?.GEAR?.NUM}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('Gearbox.Number', 'شماره دنده')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
              </Box>
            </CardEngineInfo>
          )}
          {lastObd?.INJECT !== undefined &&
            (lastObd?.INJECT?.B1.ST!== 0.0 ||
              lastObd?.INJECT?.B1.LT!== 0.0 ||
              lastObd?.INJECT?.B2.ST!== 0.0 ||
              lastObd?.INJECT?.B2.LT!== 0.0 ||
              lastObd?.INJECT?.TI.C1!== 0.0 ||
              lastObd?.INJECT?.TI.C2!== 0.0 ||
              lastObd?.INJECT?.TI.C3!== 0.0 ||
              lastObd?.INJECT?.TI.C4!== 0.0 ||
              lastObd?.INJECT?.TI.C5!== 0.0 ||
              lastObd?.INJECT?.TI.C6!== 0.0 ||
              lastObd?.INJECT?.TI.C7!== 0.0 ||
              lastObd?.INJECT?.TI.C8!== 0.0 ||
              lastObd?.INJECT?.TI.AVG.B1!== 0.0 ||
              lastObd?.INJECT?.TI.AVG.B2 !== 0.0) && (
              <CardEngineInfo title='پاشش سوخت'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.INJECT?.B1?.LT !== undefined &&
                    lastObd?.INJECT?.B1?.LT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب افزودنی سوخت بانک 1</Typography>
                          <Typography>{lastObd?.INJECT?.B1?.LT}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.Bank1.Ltft', 'ضریب افزودنی سوخت بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.INJECT?.B1?.ST !== undefined &&
                    lastObd?.INJECT?.B1?.ST!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب ضربی سوخت بانک یک </Typography>
                          <Typography>{lastObd?.INJECT?.B1?.ST}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.Bank1.Stft', 'ضریب ضربی سوخت بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.INJECT?.B2?.LT !== undefined &&
                    lastObd?.INJECT?.B2?.LT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب افزودنی سوخت بانک دو </Typography>
                          <Typography>{lastObd?.INJECT?.B2?.LT}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.Bank2.Ltft', 'ضریب افزودنی سوخت بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.INJECT?.B2?.ST !== undefined &&
                    lastObd?.INJECT?.B2?.ST!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب ضربی سوخت بانک دو </Typography>
                          <Typography>{lastObd?.INJECT?.B2?.ST}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.Bank2.Stft', 'ضریب ضربی سوخت بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.INJECT?.TI?.C1 !== undefined &&
                    lastObd?.INJECT?.TI?.C1!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش انژکتور 1 </Typography>
                          <Typography>{lastObd?.INJECT?.TI?.C1}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.InjectionTime.InjectionTime1', 'زمان پاشش انژکتور 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.INJECT?.TI?.C2 !== undefined &&
                    lastObd?.INJECT?.TI?.C2!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش انژکتور 2</Typography>
                          <Typography>{lastObd?.INJECT?.TI?.C2}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.InjectionTime.InjectionTime2', 'زمان پاشش انژکتور 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.INJECT?.TI?.C3 !== undefined &&
                    lastObd?.INJECT?.TI?.C3!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش انژکتور 3</Typography>
                          <Typography>{lastObd?.INJECT?.TI?.C3}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.InjectionTime.InjectionTime3', 'زمان پاشش انژکتور 3')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.INJECT?.TI?.C4 !== undefined &&
                    lastObd?.INJECT?.TI?.C4!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش انژکتور 4</Typography>
                          <Typography>{lastObd?.INJECT?.TI?.C4}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.InjectionTime.InjectionTime4', 'زمان پاشش انژکتور 4')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.INJECT?.TI?.C5 !== undefined &&
                    lastObd?.INJECT?.TI?.C5!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش انژکتور 5</Typography>
                          <Typography>{lastObd?.INJECT?.TI?.C5}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.InjectionTime.InjectionTime5', 'زمان پاشش انژکتور 5')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.INJECT?.TI?.C6 !== undefined &&
                    lastObd?.INJECT?.TI?.C6!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش انژکتور 6</Typography>
                          <Typography>{lastObd?.INJECT?.TI?.C6}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.InjectionTime.InjectionTime6', 'زمان پاشش انژکتور 6')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.INJECT?.TI?.C7 !== undefined &&
                    lastObd?.INJECT?.TI?.C7!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش انژکتور 7</Typography>
                          <Typography>{lastObd?.INJECT?.TI?.C7}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.InjectionTime.InjectionTime7', 'زمان پاشش انژکتور 7')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.INJECT?.TI?.C8 !== undefined &&
                    lastObd?.INJECT?.TI?.C8!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش انژکتور 8</Typography>
                          <Typography>{lastObd?.INJECT?.TI?.C8}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.InjectionTime.InjectionTime8', 'زمان پاشش انژکتور 8')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.INJECT?.TI?.AVG?.B1 !== undefined &&
                    lastObd?.INJECT?.TI?.AVG?.B1!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش عمومی بانک یک</Typography>
                          <Typography>{lastObd?.INJECT?.TI?.AVG?.B1}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.InjectionTime.AVG.Bank1', 'زمان پاشش عمومی بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.INJECT?.TI?.AVG?.B2 !== undefined &&
                    lastObd?.INJECT?.TI?.AVG?.B2!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش عمومی بانک 2</Typography>
                          <Typography>{lastObd?.INJECT?.TI?.AVG?.B2}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Injection.InjectionTime.AVG.Bank2', 'زمان پاشش عمومی بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.KNOCK !== undefined &&
            (lastObd?.KNOCK?.C1!== 0.0 ||
              lastObd?.KNOCK.C2!== 0.0 ||
              lastObd?.KNOCK.C3!== 0.0 ||
              lastObd?.KNOCK.C4!== 0.0 ||
              lastObd?.KNOCK.C5!== 0.0 ||
              lastObd?.KNOCK.C6!== 0.0 ||
              lastObd?.KNOCK.C7!== 0.0 ||
              lastObd?.KNOCK.C8 !== 0.0) && (
              <CardEngineInfo title='حسگر ضربه'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.KNOCK?.C1 !== undefined &&
                    lastObd?.KNOCK?.C1!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>مقدار حسگر ضربه یک</Typography>
                          <Typography>{lastObd?.KNOCK?.C1}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Knock.Value1', 'مقدار حسگر ضربه 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.KNOCK?.C2 !== undefined &&
                    lastObd?.KNOCK?.C2!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>مقدار حسگر ضربه دو</Typography>
                          <Typography>{lastObd?.KNOCK?.C2}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Knock.Value2', 'مقدار حسگر ضربه 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.KNOCK?.C3 !== undefined &&
                    lastObd?.KNOCK?.C3!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>مقدار حسگر ضربه سه</Typography>
                          <Typography>{lastObd?.KNOCK?.C3}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Knock.Value3', 'مقدار حسگر ضربه 3')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.KNOCK?.C4 !== undefined &&
                    lastObd?.KNOCK?.C4!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>مقدار حسگر ضربه چهار</Typography>
                          <Typography>{lastObd?.KNOCK?.C4}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Knock.Value4', 'مقدار حسگر ضربه 4')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.KNOCK?.C5 !== undefined &&
                    lastObd?.KNOCK?.C5!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>مقدار حسگر ضربه پنج</Typography>
                          <Typography>{lastObd?.KNOCK?.C5}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Knock.Value5', 'مقدار حسگر ضربه 5')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.KNOCK?.C6 !== undefined &&
                    lastObd?.KNOCK?.C6!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>مقدار حسگر ضربه شش</Typography>
                          <Typography>{lastObd?.KNOCK?.C6}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Knock.Value6', 'مقدار حسگر ضربه 6')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.KNOCK?.C7 !== undefined &&
                    lastObd?.KNOCK?.C7!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>مقدار حسگر ضربه هفت</Typography>
                          <Typography>{lastObd?.KNOCK?.C7}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Knock.Value7', 'مقدار حسگر ضربه 7')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.KNOCK?.C8 !== undefined &&
                    lastObd?.KNOCK?.C8!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>مقدار حسگر ضربه هشت</Typography>
                          <Typography>{lastObd?.KNOCK?.C8}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Knock.Value8', 'مقدار حسگر ضربه 8')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.MAF !== undefined &&
            (lastObd?.MAF?.VA!== 0.0 ||
              lastObd?.MAF?.CO !== 0.0) && (
              <CardEngineInfo title='حسگر اندازه گیری جرم هوای ورودی'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.MAF?.VA !== undefined &&
                    lastObd?.MAF?.VA!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>جریان هوا</Typography>
                          <Typography>{lastObd?.MAF?.VA}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('MAF.MassFlowRate', 'جریان هوا')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.MAF?.CO !== undefined &&
                    lastObd?.MAF?.CO!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب اصلاح جریان هوا</Typography>
                          <Typography>{lastObd?.MAF?.CO}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('MAF.MAFCoefficient', 'ضریب اصلاح جریان هوا')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.OIL !== undefined && lastObd?.OIL?.TE!== 0.0 && (
            <CardEngineInfo title='روغن'>
              <Box display='flex' flexDirection='column'>
                {lastObd?.OIL?.TE !== undefined && lastObd?.OIL?.TE!== 0.0 && (
                  <Box display='flex' justifyContent='space-between'>
                    <Box
                      alignItems='center'
                      display='flex'
                      justifyContent='space-between'
                      width='200px'
                    >
                      <Typography>دمای روغن موتور</Typography>
                      <Typography>{lastObd?.OIL?.TE}</Typography>
                    </Box>
                    <IconButton onClick={() => handleGeneral('Oil.Temp', 'دمای روغن موتور')}>
                      <TimelineIcon
                        sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                      />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </CardEngineInfo>
          )}
          {lastObd?.OXYGEN !== undefined &&
            (lastObd?.OXYGEN?.B1?.S1?.VO!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S1?.HE!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S1?.ST!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S1?.LT!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S2?.VO!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S2?.HE!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S2?.ST!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S2?.LT!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S3?.VO!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S3?.HE!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S3?.ST!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S3?.LT!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S4?.VO!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S4?.HE!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S4?.ST!== 0.0 ||
              lastObd?.OXYGEN?.B1?.S4?.LT!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S1?.VO!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S1?.HE!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S1?.ST!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S1?.LT!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S2?.VO!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S2?.HE!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S2?.ST!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S2?.LT!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S3?.VO!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S3?.HE!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S3?.ST!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S3?.LT!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S4?.VO!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S4?.HE!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S4?.ST!== 0.0 ||
              lastObd?.OXYGEN?.B2?.S4?.LT !== 0.0) && (
              <CardEngineInfo title='حسگر اکسیژن'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.OXYGEN?.B1?.S1?.VO !== undefined &&
                    lastObd?.OXYGEN?.B1?.S1?.VO!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ولتاژ حسگر اکسیژن 1 بانک 1 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S1?.VO}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor1.Volt', 'ولتاژ حسگر اکسیژن 1 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S1?.HE !== undefined &&
                    lastObd?.OXYGEN?.B1?.S1?.HE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>وضعیت حسگر اکسیژن 1 بانک 1 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S1?.HE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor1.Heat', 'وضعیت حسگر اکسیژن 1 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S1?.ST !== undefined &&
                    lastObd?.OXYGEN?.B1?.S1?.ST!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب اصلاح حسگر اکسیژن 1 بانک 1 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S1?.ST}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor1.Stft', 'ضریب اصلاح حسگر اکسیژن 1 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S1?.LT !== undefined &&
                    lastObd?.OXYGEN?.B1?.S1?.LT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب افزودنی حسگر اکسیژن 1 بانک 1</Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S1?.LT}</Typography>
                        </Box>

                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor1.Ltft', 'ضریب افزودنی حسگر اکسیژن 1 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S2?.VO !== undefined &&
                    lastObd?.OXYGEN?.B1?.S2?.VO!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ولتاژ حسگر اکسیژن 2 بانک 1 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S2?.VO}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor2.Volt', 'ولتاژ حسگر اکسیژن 2 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S2?.HE !== undefined &&
                    lastObd?.OXYGEN?.B1?.S2?.HE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>وضعیت حسگر اکسیژن 2 بانک 1 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S2?.HE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor2.Heat', 'وضعیت حسگر اکسیژن 2 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S2?.ST !== undefined &&
                    lastObd?.OXYGEN?.B1?.S2?.ST!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب اصلاح حسگر اکسیژن 2 بانک 1 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S2?.ST}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor2.Stft', 'ضریب اصلاح حسگر اکسیژن 2 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S2?.LT !== undefined &&
                    lastObd?.OXYGEN?.B1?.S2?.LT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب افزودنی حسگر اکسیژن 2 بانک 1</Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S2?.LT}</Typography>
                        </Box>

                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor2.Ltft', 'ضریب افزودنی حسگر اکسیژن 2 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S3?.VO !== undefined &&
                    lastObd?.OXYGEN?.B1?.S3?.VO!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ولتاژ حسگر اکسیژن 3 بانک 1 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S3?.VO}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor3.Volt', 'ولتاژ حسگر اکسیژن 3 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S3?.HE !== undefined &&
                    lastObd?.OXYGEN?.B1?.S3?.HE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>وضعیت حسگر اکسیژن 3 بانک 1 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S3?.HE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor3.Heat', 'وضعیت حسگر اکسیژن 3 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S3?.ST !== undefined &&
                    lastObd?.OXYGEN?.B1?.S3?.ST!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب اصلاح حسگر اکسیژن 3 بانک 1 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S3?.ST}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor3.Stft', 'ضریب اصلاح حسگر اکسیژن 3 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S3?.LT !== undefined &&
                    lastObd?.OXYGEN?.B1?.S3?.LT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب افزودنی حسگر اکسیژن 3 بانک 1</Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S3?.LT}</Typography>
                        </Box>

                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor3.Ltft', 'ضریب افزودنی حسگر اکسیژن 3 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S4?.VO !== undefined &&
                    lastObd?.OXYGEN?.B1?.S4?.VO!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ولتاژ حسگر اکسیژن 4 بانک 1 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S4?.VO}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor4.Volt', 'ولتاژ حسگر اکسیژن 4 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S4?.HE !== undefined &&
                    lastObd?.OXYGEN?.B1?.S4?.HE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>وضعیت حسگر اکسیژن 4 بانک 1 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S4?.HE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor4.Heat', 'وضعیت حسگر اکسیژن 4 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S4?.ST !== undefined &&
                    lastObd?.OXYGEN?.B1?.S4?.ST!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب اصلاح حسگر اکسیژن 4 بانک 1 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S4?.ST}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor4.Stft', 'ضریب اصلاح حسگر اکسیژن 4 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B1?.S4?.LT !== undefined &&
                    lastObd?.OXYGEN?.B1?.S4?.LT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب افزودنی حسگر اکسیژن 4 بانک 1</Typography>
                          <Typography>{lastObd?.OXYGEN?.B1?.S4?.LT}</Typography>
                        </Box>

                        <IconButton onClick={() => handleGeneral('Oxygen.Bank1.Sensor4.Ltft', 'ضریب افزودنی حسگر اکسیژن 4 بانک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S1?.VO !== undefined &&
                    lastObd?.OXYGEN?.B2?.S1?.VO!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ولتاژ حسگر اکسیژن 1 بانک 2 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S1?.VO}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor1.Volt', 'ولتاژ حسگر اکسیژن 1 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S1?.HE !== undefined &&
                    lastObd?.OXYGEN?.B2?.S1?.HE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>وضعیت حسگر اکسیژن 1 بانک 2 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S1?.HE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor1.Heat', 'وضعیت حسگر اکسیژن 1 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S1?.ST !== undefined &&
                    lastObd?.OXYGEN?.B2?.S1?.ST!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب اصلاح حسگر اکسیژن 1 بانک 2 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S1?.ST}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor1.Stft', 'ضریب اصلاح حسگر اکسیژن 1 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S1?.LT !== undefined &&
                    lastObd?.OXYGEN?.B2?.S1?.LT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب افزودنی حسگر اکسیژن 1 بانک 2</Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S1?.LT}</Typography>
                        </Box>

                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor1.Ltft', 'ضریب افزودنی حسگر اکسیژن 1 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S2?.VO !== undefined &&
                    lastObd?.OXYGEN?.B2?.S2?.VO!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ولتاژ حسگر اکسیژن 2 بانک 2 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S2?.VO}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor2.Volt', 'ولتاژ حسگر اکسیژن 2 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S2?.HE !== undefined &&
                    lastObd?.OXYGEN?.B2?.S2?.HE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>وضعیت حسگر اکسیژن 2 بانک 2 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S2?.HE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor2.Heat', 'وضعیت حسگر اکسیژن 2 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S2?.ST !== undefined &&
                    lastObd?.OXYGEN?.B2?.S2?.ST!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب اصلاح حسگر اکسیژن 2 بانک 2 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S2?.ST}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor2.Stft', 'ضریب اصلاح حسگر اکسیژن 2 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S2?.LT !== undefined &&
                    lastObd?.OXYGEN?.B2?.S2?.LT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب افزودنی حسگر اکسیژن 2 بانک 2</Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S2?.LT}</Typography>
                        </Box>

                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor2.Ltft', 'ضریب افزودنی حسگر اکسیژن 2 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S3?.VO !== undefined &&
                    lastObd?.OXYGEN?.B2?.S3?.VO!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ولتاژ حسگر اکسیژن 3 بانک 2 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S3?.VO}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor3.Volt', 'ولتاژ حسگر اکسیژن 3 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S3?.HE !== undefined &&
                    lastObd?.OXYGEN?.B2?.S3?.HE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>وضعیت حسگر اکسیژن 3 بانک 2 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S3?.HE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor3.Heat', 'وضعیت حسگر اکسیژن 3 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S3?.ST !== undefined &&
                    lastObd?.OXYGEN?.B2?.S3?.ST!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب اصلاح حسگر اکسیژن 3 بانک 2 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S3?.ST}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor3.Stft', 'ضریب اصلاح حسگر اکسیژن 3 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S3?.LT !== undefined &&
                    lastObd?.OXYGEN?.B2?.S3?.LT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب افزودنی حسگر اکسیژن 3 بانک 2</Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S3?.LT}</Typography>
                        </Box>

                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor3.Ltft', 'ضریب افزودنی حسگر اکسیژن 3 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S4?.VO !== undefined &&
                    lastObd?.OXYGEN?.B2?.S4?.VO!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ولتاژ حسگر اکسیژن 4 بانک 2 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S4?.VO}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor4.Volt', 'ولتاژ حسگر اکسیژن 4 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S4?.HE !== undefined &&
                    lastObd?.OXYGEN?.B2?.S4?.HE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>وضعیت حسگر اکسیژن 4 بانک 2 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S4?.HE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor4.Heat', 'وضعیت حسگر اکسیژن 4 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S4?.ST !== undefined &&
                    lastObd?.OXYGEN?.B2?.S4?.ST!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب اصلاح حسگر اکسیژن 4 بانک 2 </Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S4?.ST}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor4.Stft', 'ضریب اصلاح حسگر اکسیژن 4 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.OXYGEN?.B2?.S4?.LT !== undefined &&
                    lastObd?.OXYGEN?.B2?.S4?.LT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ضریب افزودنی حسگر اکسیژن 4 بانک 2</Typography>
                          <Typography>{lastObd?.OXYGEN?.B2?.S4?.LT}</Typography>
                        </Box>

                        <IconButton onClick={() => handleGeneral('Oxygen.Bank2.Sensor4.Ltft', 'ضریب افزودنی حسگر اکسیژن 4 بانک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.RPM !== undefined &&
            (lastObd?.RPM?.IS!== 0.0 || lastObd?.RPM?.RP !== 0.0) && (
              <CardEngineInfo title='دور موتور'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.RPM?.IS !== undefined && lastObd?.RPM?.IS!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>نقطه تنظیم دور آرام</Typography>
                        <Typography>{lastObd?.RPM?.IS}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('RPM.IdleSet', 'نقطه تنظیم دور آرام')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.RPM?.RP !== undefined && lastObd?.RPM?.RP!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>دور موتور</Typography>
                        <Typography>{lastObd?.RPM?.RP}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('RPM.Value', 'دور موتور')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.STEP !== undefined &&
            (lastObd?.STEP?.PI!== 0.0 || lastObd?.STEP?.TR !== 0.0) && (
              <CardEngineInfo title='استپر موتور'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.STEP?.PI !== undefined &&
                    lastObd?.STEP?.PI!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تعداد گام استپر موتور</Typography>
                          <Typography>{lastObd?.STEP?.PI}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Stepper.Step', 'تعداد گام استپر موتور')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.STEP?.TR !== undefined &&
                    lastObd?.STEP?.TR!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>اصلاح تعداد گام</Typography>
                          <Typography>{lastObd?.STEP?.TR}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Stepper.Trim', 'اصلاح تعداد گام')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.TPS !== undefined &&
            (lastObd?.TPS?.POSB?.VO!== 0.0 ||
              lastObd?.TPS?.POSB?.AB!== 0.0 ||
              lastObd?.TPS?.POSB?.OS!== 0.0 ||
              lastObd?.TPS?.POSC?.VO!== 0.0 ||
              lastObd?.TPS?.POSC?.AB!== 0.0 ||
              lastObd?.TPS?.POSC?.OS!== 0.0 ||
              lastObd?.TPS?.CA!== 0.0 ||
              lastObd?.TPS?.CM!== 0.0 ||
              lastObd?.TPS?.ID !== 0.0) && (
              <CardEngineInfo title='حسگر دریچه گاز'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.TPS?.POSB?.OS !== undefined && lastObd?.TPS?.POSB?.OS!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>افست زاویه دریچه گاز B</Typography>
                        <Typography>{lastObd?.TPS?.POSB?.OS}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('TPS.PosB.Offset', 'افست زاویه دریچه گاز B')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.TPS?.POSC?.OS !== undefined && lastObd?.TPS?.POSC?.OS!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>افست زاویه دریچه گاز C</Typography>
                        <Typography>{lastObd?.TPS?.POSC?.OS}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('TPS.PosC.Offset', 'افست زاویه دریچه گاز C')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.TPS?.POSB?.AB !== undefined && lastObd?.TPS.POSB?.AB!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography> زاویه دریچه گاز B</Typography>
                        <Typography>{lastObd?.TPS?.POSB?.AB}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('TPS.PosB.Pos', 'زاویه دریچه گاز B')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.TPS?.POSC?.AB !== undefined && lastObd?.TPS?.POSC?.AB!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>زاویه دریچه گاز C</Typography>
                        <Typography>{lastObd?.TPS?.POSC?.AB}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('TPS.PosC.Pos', 'زاویه دریچه گاز C')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.TPS?.CM !== undefined && lastObd?.TPS?.CM!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>زاویه دریچه گاز مورد نظر</Typography>
                        <Typography>{lastObd?.TPS?.CM}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('TPS.PosCMD', 'زاویه دریچه گاز مورد نظر')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.TPS?.CA !== undefined && lastObd?.TPS?.CA!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>زاویه دریچه گاز محاسبه شده</Typography>
                        <Typography>{lastObd?.TPS?.CA}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('TPS.PosCal', 'زاویه دریچه گاز محاسبه شده')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.TPS?.ID !== undefined && lastObd?.TPS?.ID!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>وضعیت دریچه گاز</Typography>
                        <Typography>{lastObd?.TPS?.ID}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('TPS.IdlePos', 'وضعیت دریچه گاز')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.TPS?.POSB?.VO !== undefined && lastObd?.TPS?.POSB?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography> ولتاژ حسگر دریچه گاز B</Typography>
                        <Typography>{lastObd?.TPS?.POSB?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('TPS.PosB.Volt', 'ولتاژ حسگر دریچه گاز B')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.TPS?.POSC?.VO !== undefined && lastObd?.TPS?.POSC?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ حسگر دریچه گاز C</Typography>
                        <Typography>{lastObd?.TPS?.POSC?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('TPS.PosC.Volt', 'ولتاژ حسگر دریچه گاز C')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.VSS !== undefined &&
            (lastObd?.VSS?.SP!== 0.0 || lastObd?.VSS?.SF !== 0.0) && (
              <CardEngineInfo title='حسگر سرعت'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.VSS?.SF !== undefined && lastObd?.VSS?.SF!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>تعداد خطاهای حسگر سرعت</Typography>
                        <Typography>{lastObd?.VSS?.SF}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('VSS.Fault', 'تعداد خطاهای حسگر سرعت')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.VSS?.SP !== undefined && lastObd?.VSS?.SP!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>سرعت خودرو</Typography>
                        <Typography>{lastObd?.VSS?.SP}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('VSS.Speed', 'سرعت خودرو')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.MAP !== undefined &&
            (lastObd?.MAP?.PR!== 0.0 || lastObd?.MAP?.VO !== 0.0) && (
              <CardEngineInfo title='حسگر اندازه گیری فشار هوای ورودی'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.MAP?.PR !== undefined && lastObd?.MAP?.PR!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>فشار منیوفلد</Typography>
                        <Typography>{lastObd?.MAP?.PR}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('MAP.Press', 'فشار منیوفلد')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.MAP?.VO !== undefined && lastObd?.MAP?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ حسگر فشار منیوفلد</Typography>
                        <Typography>{lastObd?.MAP?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('MAP.Volt', 'ولتاژ حسگر فشار منیوفلد')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.IAT !== undefined &&
            (lastObd?.IAT?.TE!== 0.0 || lastObd?.IAT?.VO !== 0.0) && (
              <CardEngineInfo title='حسگر اندازه گیری دمای هوای ورودی'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.IAT?.TE !== undefined && lastObd?.IAT?.TE!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>دمای هوای ورودی منیوفلد</Typography>
                        <Typography>{lastObd?.IAT?.TE}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('IAT.Temp', 'دمای هوای ورودی منیوفلد')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.IAT?.VO !== undefined && lastObd?.IAT?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ حسگر دمای ورودی منیوفلد</Typography>
                        <Typography>{lastObd?.IAT?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('IAT.Volt', 'ولتاژ حسگر دمای ورودی منیوفلد')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.COMB !== undefined &&
            (lastObd?.COMB?.AFR!== 0.0 ||
              lastObd?.COMB?.MF?.C1!== 0.0 ||
              lastObd?.COMB?.MF?.C2!== 0.0 ||
              lastObd?.COMB?.MF?.C3!== 0.0 ||
              lastObd?.COMB?.MF?.C4!== 0.0 ||
              lastObd?.COMB?.MF?.C5!== 0.0 ||
              lastObd?.COMB?.MF?.C6!== 0.0 ||
              lastObd?.COMB?.MF?.C7!== 0.0 ||
              lastObd?.COMB?.MF?.C8!== 0.0 ||
              lastObd?.COMB?.TD?.C1!== 0.0 ||
              lastObd?.COMB?.TD?.C2!== 0.0 ||
              lastObd?.COMB?.TD?.C3!== 0.0 ||
              lastObd?.COMB?.TD?.C4!== 0.0 ||
              lastObd?.COMB?.TD?.C5!== 0.0 ||
              lastObd?.COMB?.TD?.C6!== 0.0 ||
              lastObd?.COMB?.TD?.C7!== 0.0 ||
              lastObd?.COMB?.TD?.C8!== 0.0 ||
              lastObd?.COMB?.TD?.AVG!== 0.0 ||
              lastObd?.COMB?.TR?.C1!== 0.0 ||
              lastObd?.COMB?.TR?.C2!== 0.0 ||
              lastObd?.COMB?.TR?.C3!== 0.0 ||
              lastObd?.COMB?.TR?.C4!== 0.0 ||
              lastObd?.COMB?.TR?.C5!== 0.0 ||
              lastObd?.COMB?.TR?.C6!== 0.0 ||
              lastObd?.COMB?.TR?.C7!== 0.0 ||
              lastObd?.COMB?.TR?.C8!== 0.0 ||
              lastObd?.COMB?.TN?.C1!== 0.0 ||
              lastObd?.COMB?.TN?.C2!== 0.0 ||
              lastObd?.COMB?.TN?.C3!== 0.0 ||
              lastObd?.COMB?.TN?.C4!== 0.0 ||
              lastObd?.COMB?.TN?.C5!== 0.0 ||
              lastObd?.COMB?.TN?.C6!== 0.0 ||
              lastObd?.COMB?.TN?.C7!== 0.0 ||
              lastObd?.COMB?.TN?.C8!== 0.0 ||
              lastObd?.COMB?.TN?.AVG !== 0.0) && (
              <CardEngineInfo title='احتراق'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.COMB?.AFR !== undefined &&
                    lastObd?.COMB?.AFR!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>نسبت سوخت به هوا</Typography>
                          <Typography>{lastObd?.COMB?.AFR}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.AFR', 'نسبت سوخت به هوا')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.MF?.C1 !== undefined &&
                    lastObd?.COMB?.MF?.C1!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>احتراق ناقص1</Typography>
                          <Typography>{lastObd?.COMB?.MF?.C1}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.MisFire.MisFire1', 'احتراق ناقص 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.MF?.C2 !== undefined &&
                    lastObd?.COMB?.MF?.C2!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>احتراق ناقص2</Typography>
                          <Typography>{lastObd?.COMB?.MF?.C2}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.MisFire.MisFire2', 'احتراق ناقص 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.MF?.C3 !== undefined &&
                    lastObd?.COMB?.MF?.C3!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>احتراق ناقص3</Typography>
                          <Typography>{lastObd?.COMB?.MF?.C3}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.MisFire.MisFire3', 'احتراق ناقص 3')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.MF?.C4 !== undefined &&
                    lastObd?.COMB?.MF?.C4!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>احتراق ناقص4</Typography>
                          <Typography>{lastObd?.COMB?.MF?.C4}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.MisFire.MisFire4', 'احتراق ناقص 4')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.MF?.C5 !== undefined &&
                    lastObd?.COMB?.MF?.C5!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>احتراق ناقص5</Typography>
                          <Typography>{lastObd?.COMB?.MF?.C5}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.MisFire.MisFire5', 'احتراق ناقص 5')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.MF?.C6 !== undefined &&
                    lastObd?.COMB?.MF?.C6!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>احتراق ناقص6</Typography>
                          <Typography>{lastObd?.COMB?.MF?.C6}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.MisFire.MisFire6', 'احتراق ناقص 6')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.MF?.C7 !== undefined &&
                    lastObd?.COMB?.MF?.C7!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>احتراق ناقص7</Typography>
                          <Typography>{lastObd?.COMB?.MF?.C7}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.MisFire.MisFire7', 'احتراق ناقص 7')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.MF?.C8 !== undefined &&
                    lastObd?.COMB?.MF?.C8!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>احتراق ناقص8</Typography>
                          <Typography>{lastObd?.COMB?.MF?.C8}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.MisFire.MisFire8', 'احتراق ناقص 8')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TD?.AVG !== undefined &&
                    lastObd?.COMB?.TD?.AVG!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زاویه جرقه زنی متوسط</Typography>
                          <Typography>{lastObd?.COMB?.TD?.AVG}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingAdvance.AVG', 'زاویه جرقه زنی متوسط')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TD?.C1 !== undefined &&
                    lastObd?.COMB?.TD?.C1!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زاویه جرقه زنی 1</Typography>
                          <Typography>{lastObd?.COMB?.TD?.C1}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingAdvance.TimingAdvance1', 'زاویه جرقه زنی 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TD?.C2 !== undefined &&
                    lastObd?.COMB?.TD?.C2!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زاویه جرقه زنی 2</Typography>
                          <Typography>{lastObd?.COMB?.TD?.C2}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingAdvance.TimingAdvance2', 'زاویه جرقه زنی 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TD?.C3 !== undefined &&
                    lastObd?.COMB?.TD?.C3!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زاویه جرقه زنی 3</Typography>
                          <Typography>{lastObd?.COMB?.TD?.C3}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingAdvance.TimingAdvance3', 'زاویه جرقه زنی 3')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TD?.C4 !== undefined &&
                    lastObd?.COMB?.TD?.C4!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زاویه جرقه زنی 4</Typography>
                          <Typography>{lastObd?.COMB?.TD?.C4}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingAdvance.TimingAdvance4', 'زاویه جرقه زنی 4')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TD?.C5 !== undefined &&
                    lastObd?.COMB?.TD?.C5!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زاویه جرقه زنی 5</Typography>
                          <Typography>{lastObd?.COMB?.TD?.C5}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingAdvance.TimingAdvance5', 'زاویه جرقه زنی 5')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TD?.C6 !== undefined &&
                    lastObd?.COMB?.TD?.C6!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زاویه جرقه زنی 6</Typography>
                          <Typography>{lastObd?.COMB?.TD?.C6}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingAdvance.TimingAdvance6', 'زاویه جرقه زنی 6')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TD?.C7 !== undefined &&
                    lastObd?.COMB?.TD?.C7!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زاویه جرقه زنی 7</Typography>
                          <Typography>{lastObd?.COMB?.TD?.C7}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingAdvance.TimingAdvance7', 'زاویه جرقه زنی 7')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TD?.C8 !== undefined &&
                    lastObd?.COMB?.TD?.C8!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زاویه جرقه زنی 8</Typography>
                          <Typography>{lastObd?.COMB?.TD?.C8}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingAdvance.TimingAdvance8', 'زاویه جرقه زنی 8')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TR?.C1 !== undefined &&
                    lastObd?.COMB?.TR?.C1!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی1 </Typography>
                          <Typography>{lastObd?.COMB?.TR?.C1}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetard.TimingRetard1', 'تاخیر جرقه زنی 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TR?.C2 !== undefined &&
                    lastObd?.COMB?.TR?.C2!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی2 </Typography>
                          <Typography>{lastObd?.COMB?.TR?.C2}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetard.TimingRetard2', 'تاخیر جرقه زنی 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TR?.C3 !== undefined &&
                    lastObd?.COMB?.TR?.C3!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی3 </Typography>
                          <Typography>{lastObd?.COMB?.TR?.C3}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetard.TimingRetard3', 'تاخیر جرقه زنی 3')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TR?.C4 !== undefined &&
                    lastObd?.COMB?.TR?.C4!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی4 </Typography>
                          <Typography>{lastObd?.COMB?.TR?.C4}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetard.TimingRetard4', 'تاخیر جرقه زنی 4')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TR?.C5 !== undefined &&
                    lastObd?.COMB?.TR?.C5!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی5 </Typography>
                          <Typography>{lastObd?.COMB?.TR?.C5}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetard.TimingRetard5', 'تاخیر جرقه زنی 5')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TR?.C6 !== undefined &&
                    lastObd?.COMB?.TR?.C6!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی6 </Typography>
                          <Typography>{lastObd?.COMB?.TR?.C6}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetard.TimingRetard6', 'تاخیر جرقه زنی 6')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TR?.C7 !== undefined &&
                    lastObd?.COMB?.TR?.C7!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی7 </Typography>
                          <Typography>{lastObd?.COMB?.TR?.C7}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetard.TimingRetard7', 'تاخیر جرقه زنی 7')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TR?.C8 !== undefined &&
                    lastObd?.COMB?.TR?.C8!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی8 </Typography>
                          <Typography>{lastObd?.COMB?.TR?.C8}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetard.TimingRetard8', 'تاخیر جرقه زنی 8')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TN?.C1 !== undefined &&
                    lastObd?.COMB?.TN?.C1!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی ناک1</Typography>
                          <Typography>{lastObd?.COMB?.TN?.C1}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetardKnock.TimingRetardKnock1', 'تاخیر جرقه زنی ناک 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TN?.C2 !== undefined &&
                    lastObd?.COMB?.TN?.C2!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی ناک2</Typography>
                          <Typography>{lastObd?.COMB?.TN?.C2}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetardKnock.TimingRetardKnock2', 'تاخیر جرقه زنی ناک 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TN?.C3 !== undefined &&
                    lastObd?.COMB?.TN?.C3!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی ناک3</Typography>
                          <Typography>{lastObd?.COMB?.TN?.C3}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetardKnock.TimingRetardKnock3', 'تاخیر جرقه زنی ناک 3')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TN?.C4 !== undefined &&
                    lastObd?.COMB?.TN?.C4!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی ناک4</Typography>
                          <Typography>{lastObd?.COMB?.TN?.C4}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetardKnock.TimingRetardKnock4', 'تاخیر جرقه زنی ناک 4')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TN?.C5 !== undefined &&
                    lastObd?.COMB?.TN?.C5!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی ناک5</Typography>
                          <Typography>{lastObd?.COMB?.TN?.C5}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetardKnock.TimingRetardKnock5', 'تاخیر جرقه زنی ناک 5')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TN?.C6 !== undefined &&
                    lastObd?.COMB?.TN?.C6!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی ناک6</Typography>
                          <Typography>{lastObd?.COMB?.TN?.C6}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetardKnock.TimingRetardKnock6', 'تاخیر جرقه زنی ناک 6')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TN?.C7 !== undefined &&
                    lastObd?.COMB?.TN?.C7!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی ناک7</Typography>
                          <Typography>{lastObd?.COMB?.TN?.C7}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetardKnock.TimingRetardKnock7', 'تاخیر جرقه زنی ناک 7')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TN?.C8 !== undefined &&
                    lastObd?.COMB?.TN?.C8!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی ناک8</Typography>
                          <Typography>{lastObd?.COMB?.TN?.C8}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetardKnock.TimingRetardKnock8', 'تاخیر جرقه زنی ناک 8')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.COMB?.TN?.AVG !== undefined &&
                    lastObd?.COMB?.TN?.AVG!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>تاخیر جرقه زنی ناک متوسط </Typography>
                          <Typography>{lastObd?.COMB?.TN?.AVG}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Combustion.TimingRetardKnock.TimingRetardKnockAVG', 'تاخیر جرقه زنی ناک متوسط')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.ATS !== undefined &&
            (lastObd?.ATS?.TE!== 0.0 || lastObd?.ATS?.VO !== 0.0) && (
              <CardEngineInfo title='حسگر اندازه گیری دمای محیط'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.ATS?.TE !== undefined && lastObd?.ATS?.TE!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>دمای محیط</Typography>
                        <Typography>{lastObd?.ATS?.TE}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('ATS.Temp', 'دمای محیط')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.ATS?.VO !== undefined && lastObd?.ATS?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ حسگر دمای محیط</Typography>
                        <Typography>{lastObd?.ATS?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('ATS.Volt', 'ولتاژ حسگر دمای محیط')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.APS !== undefined &&
            (lastObd?.APS?.PR!== 0.0 || lastObd?.APS?.VO !== 0.0) && (
              <CardEngineInfo title='حسگر اندازه گیری فشار محیط'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.APS?.PR !== undefined && lastObd?.APS?.PR!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>فشار محیط</Typography>
                        <Typography>{lastObd?.APS?.PR}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('APS.Press', 'فشار محیط')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.APS?.VO !== undefined && lastObd?.APS?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ حسگر فشار محیط</Typography>
                        <Typography>{lastObd?.APS?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('APS.Volt', 'ولتاژ حسگر فشار محیط')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.APP !== undefined &&
            (lastObd?.APP?.POSD?.OS!== 0.0 ||
              lastObd?.APP?.POSE?.OS!== 0.0 ||
              lastObd?.APP?.CA!== 0.0 ||
              lastObd?.APP?.POSD?.AB!== 0.0 ||
              lastObd?.APP?.POSE?.AB!== 0.0 ||
              lastObd?.APP?.POSD?.VO!== 0.0 ||
              lastObd?.APP?.POSE?.VO !== 0.0) && (
              <CardEngineInfo title='پدال گاز'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.APP?.POSD?.OS !== undefined && lastObd?.APP?.POSD?.OS!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>Dافست موقعیت پدال گاز</Typography>
                        <Typography>{lastObd?.APP?.POSD?.OS}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('APP.PosD.Offset', 'D افست موقعیت پدال گاز')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.APP?.POSE?.OS !== undefined && lastObd?.APP?.POSE?.OS!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>Eافست موقعیت پدال گاز</Typography>
                        <Typography>{lastObd?.APP?.POSE?.OS}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('APP.PosE.Offset', 'E افست موقعیت پدال گاز')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.APP?.CA !== undefined && lastObd?.APP?.CA!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>موقعیت پدال گاز محاسبه شده</Typography>
                        <Typography>{lastObd?.APP?.CA}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('APP.PosCal', 'موقعیت پدال گاز محاسبه شده')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.APP?.POSD?.AB !== undefined && lastObd?.APP?.POSD?.AB!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>Dموقعیت پدال گاز</Typography>
                        <Typography>{lastObd?.APP?.POSD?.AB}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('APP.PosD.Pos', 'D موقعیت پدال گاز')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.APP?.POSE?.AB !== undefined && lastObd?.APP?.POSE?.AB!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>Eموقعیت پدال گاز</Typography>
                        <Typography>{lastObd?.APP?.POSE?.AB}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('APP.PosE.Pos', 'E موقعیت پدال گاز')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.APP?.POSD?.VO !== undefined && lastObd?.APP?.POSD?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>Dولتاژ حسگر پدال گاز</Typography>
                        <Typography>{lastObd?.APP?.POSD?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('APP.PosD.Volt', 'D ولتاژ حسگر پدال گاز')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.APP?.POSE?.VO !== undefined && lastObd?.APP?.POSE?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>Eولتاژ حسگر پدال گاز</Typography>
                        <Typography>{lastObd?.APP?.POSE?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('APP.PosE.Volt', 'E ولتاژ حسگر پدال گاز')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.VPS !== undefined &&
            (lastObd?.VPS?.PR!== 0.0 || lastObd?.VPS?.VO !== 0.0) && (
              <CardEngineInfo title='حسگر اندازه گیری فشار گاز کولر'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.VPS?.PR !== undefined && lastObd?.VPS?.PR!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>حسگر فشار گاز کولر</Typography>
                        <Typography>{lastObd?.VPS?.PR}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('VPS.Press', 'حسگر فشار گاز کولر')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.VPS?.VO !== undefined && lastObd?.VPS?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ حسگر فشار گاز کولر</Typography>
                        <Typography>{lastObd?.VPS?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('VPS.Volt', 'ولتاژ حسگر فشار گاز کولر')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.WGC !== undefined && lastObd?.WGC?.AN!== 0.0 && (
            <CardEngineInfo title='شیر برقی WGC'>
              <Box display='flex' flexDirection='column'>
                {lastObd?.WGC?.AN !== undefined && lastObd?.WGC?.AN!== 0.0 && (
                  <Box display='flex' justifyContent='space-between'>
                    <Box
                      alignItems='center'
                      display='flex'
                      justifyContent='space-between'
                      width='200px'
                    >
                      <Typography>WGCمقدار باز بودن شیر برقی</Typography>
                      <Typography>{lastObd?.WGC?.AN}</Typography>
                    </Box>
                    <IconButton onClick={() => handleGeneral('WGC.Angle', 'WGC مقدار باز بودن شیر برقی')}>
                      <TimelineIcon
                        sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                      />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </CardEngineInfo>
          )}
          {lastObd?.DCV !== undefined && lastObd?.DCV?.AN!== 0.0 && (
            <CardEngineInfo title='شیر برقی DCV'>
              <Box display='flex' flexDirection='column'>
                {lastObd?.DCV?.AN !== undefined && lastObd?.DCV?.AN!== 0.0 && (
                  <Box display='flex' justifyContent='space-between'>
                    <Box
                      alignItems='center'
                      display='flex'
                      justifyContent='space-between'
                      width='200px'
                    >
                      <Typography>dcvمقدار باز بودن شیر برقی</Typography>
                      <Typography>{lastObd?.DCV?.AN}</Typography>
                    </Box>
                    <IconButton onClick={() => handleGeneral('DCV.Angle', 'DCV مقدار باز بودن شیر برقی')}>
                      <TimelineIcon
                        sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                      />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </CardEngineInfo>
          )}
          {lastObd?.EVAP !== undefined &&
            (lastObd?.EVAP?.TE!== 0.0 || lastObd?.EVAP?.VO !== 0.0) && (
              <CardEngineInfo title='تبخیر کننده'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.EVAP?.TE !== undefined &&
                    lastObd?.EVAP?.TE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>دمای تبخیر کننده</Typography>
                          <Typography>{lastObd?.EVAP?.TE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Evaporator.Temp', 'دمای تبخیر کننده')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.EVAP?.VO !== undefined &&
                    lastObd?.EVAP?.VO!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>ولتاژ تبخیر کننده</Typography>
                          <Typography>{lastObd?.EVAP?.VO}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Evaporator.Volt', 'ولتاژ تبخیر کننده')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.FPS !== undefined &&
            (lastObd?.FPS?.PR!== 0.0 || lastObd?.FPS?.VO !== 0.0) && (
              <CardEngineInfo title='حسگر فشار سوخت'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.FPS?.PR !== undefined && lastObd?.FPS?.PR!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography> فشار مخزن سوخت</Typography>
                        <Typography>{lastObd?.FPS?.PR}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('FPS.Press', 'فشار مخزن سوخت')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.FPS?.VO !== undefined && lastObd?.FPS?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ حسگر فشار سوخت</Typography>
                        <Typography>{lastObd?.FPS?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('FPS.Volt', 'ولتاژ حسگر فشار سوخت')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.FRP !== undefined &&
            (lastObd?.FRP?.PR!== 0.0 || lastObd?.FRP?.VO !== 0.0) && (
              <CardEngineInfo title='حسگر فشار ریل سوخت'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.FRP?.PR !== undefined && lastObd?.FRP?.PR!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography> فشار ریل سوخت</Typography>
                        <Typography>{lastObd?.FRP?.PR}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('FRP.Press', 'فشار ریل سوخت')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.FRP?.VO !== undefined && lastObd?.FRP?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ حسگر فشار ریل سوخت</Typography>
                        <Typography>{lastObd?.FRP?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('FRP.Volt', 'ولتاژ حسگر فشار ریل سوخت')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.EFR !== undefined &&
            (lastObd?.EFR?.AVG!== 0.0 || lastObd?.EFR?.INS !== 0.0) && (
              <CardEngineInfo title='مصرف سوخت'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.EFR?.AVG !== undefined && lastObd?.EFR?.AVG!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>( در 100 km)مصرف سوخت متوسط</Typography>
                        <Typography>{lastObd?.EFR?.AVG}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('EFR.AVG', 'مصرف سوخت متوسط')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.EFR?.INS !== undefined &&
                    lastObd?.EFR?.INS!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>مصرف سوخت لحظه ای</Typography>
                          <Typography>{lastObd?.EFR?.INS}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('EFR.Instance', 'مصرف سوخت لحظه ای')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.ACCEL !== undefined && lastObd?.ACCEL?.VAL!== 0.0 && (
            <CardEngineInfo title='شتاب  لحظه ای خودرو'>
              <Box display='flex' flexDirection='column'>
                {lastObd?.ACCEL?.VAL !== undefined &&
                  lastObd?.ACCEL?.VAL!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>شتاب لحظه ای خودرو</Typography>
                        <Typography>{lastObd?.ACCEL?.VAL}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('Accelerator.Value', 'شتاب لحظه ای خودرو')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
              </Box>
            </CardEngineInfo>
          )}
          {lastObd?.BPS !== undefined &&
            (lastObd?.BPS?.PR!== 0.0 ||
              lastObd?.BPS?.VO !== 0.0) && (
              <CardEngineInfo title='حسگر فشار بوست'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.BPS?.PR !== undefined && lastObd?.BPS?.PR!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>فشار بوست</Typography>
                        <Typography>{lastObd?.BPS?.PR}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('BPS.Press', 'فشار بوست')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.BPS?.VO !== undefined && lastObd?.BPS?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ حسگر فشار بوست</Typography>
                        <Typography>{lastObd?.BPS?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('BPS.Volt', 'ولتاژ حسگر فشار بوست')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.BBS !== undefined &&
            (lastObd?.BBS?.PR!== 0.0 || lastObd?.BBS?.VO !== 0.0) && (
              <CardEngineInfo title='حسگر فشار روغن ترمز'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.BBS?.PR !== undefined && lastObd?.BBS?.PR!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>فشار روغن ترمز</Typography>
                        <Typography>{lastObd?.BBS?.PR}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('BBS.Press', 'فشار روغن ترمز')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.BBS?.VO !== undefined && lastObd?.BBS?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ حسگر فشار روغن ترمز</Typography>
                        <Typography>{lastObd?.BBS?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('BBS.Volt', 'ولتاژ حسگر فشار روغن ترمز')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.BTS !== undefined &&
            (lastObd?.BTS?.TE!== 0.0 || lastObd?.BTS?.VO !== 0.0) && (
              <CardEngineInfo title='حسگر دمای بوست'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.BTS?.TE !== undefined && lastObd?.BTS?.TE!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>دمای بوست</Typography>
                        <Typography>{lastObd?.BTS?.TE}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('BTS.Temp', 'دمای بوست')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.BTS?.VO !== undefined && lastObd?.BTS?.VO!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ولتاژ حسگر دمای بوست</Typography>
                        <Typography>{lastObd?.BTS?.VO}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('BTS.Volt', 'ولتاژ حسگر دمای بوست')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.CAT !== undefined &&
            (lastObd?.CAT?.B1?.S1?.TE!== 0.0 ||
              lastObd?.CAT?.B1?.S2?.TE!== 0.0 ||
              lastObd?.CAT?.B2?.S1?.TE!== 0.0 ||
              lastObd?.CAT?.B2?.S2?.TE !== 0.0) && (
              <CardEngineInfo title='کاتالیست'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.CAT?.B1?.S1?.TE !== undefined &&
                    lastObd?.CAT?.B1?.S1?.TE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>دمای حسگر 1 بانک 1کاتالیست </Typography>
                          <Typography>{lastObd?.CAT?.B1?.S1?.TE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Catalyst.Bank1.Sensor1.Temp', 'دمای حسگر 1 بانک 1 کاتالیست')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.CAT?.B1?.S2?.TE !== undefined &&
                    lastObd?.CAT?.B1?.S2?.TE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>دمای حسگر 2 بانک 1کاتالیست</Typography>
                          <Typography>{lastObd?.CAT?.B1?.S2?.TE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Catalyst.Bank1.Sensor2.Temp', 'دمای حسگر 2 بانک 1 کاتالیست')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.CAT?.B2?.S1?.TE !== undefined &&
                    lastObd?.CAT?.B2?.S1?.TE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>دمای حسگر1 بانک 2کاتالیست</Typography>
                          <Typography>{lastObd?.CAT?.B2?.S1?.TE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Catalyst.Bank2.Sensor1.Temp', 'دمای حسگر 1 بانک 2 کاتالیست')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.CAT?.B2?.S2?.TE !== undefined &&
                    lastObd?.CAT?.B2?.S2?.TE!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>دمای حسگر2 بانک 2کاتالیست</Typography>
                          <Typography>{lastObd?.CAT?.B2?.S2?.TE}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Catalyst.Bank2.Sensor2.Temp', 'دمای حسگر 2 بانک 2 کاتالیست')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.TOR !== undefined &&
            (lastObd?.TOR?.ABS!== 0.0 ||
              lastObd?.TOR?.CMD!== 0.0 ||
              lastObd?.TOR?.REL !== 0.0) && (
              <CardEngineInfo title='گشتاور'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.TOR?.ABS !== undefined && lastObd?.TOR?.ABS!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>گشتاور مطلق </Typography>
                        <Typography>{lastObd?.TOR?.ABS}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('Torque.ABS', 'گشتاور مطلق')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.TOR?.CMD !== undefined && lastObd?.TOR?.CMD!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>گشتاور درخواستی</Typography>
                        <Typography>{lastObd?.TOR?.CMD}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('Torque.CMD', 'گشتاور درخواستی')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.TOR?.REL !== undefined &&
                    lastObd?.TOR?.REL!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>گشتاوری نسبی</Typography>
                          <Typography>{lastObd?.TOR?.REL}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Torque.Relative', 'گشتاوری نسبی')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.BF !== undefined &&
            (lastObd?.BF?.INJECT?.C1!== 0.0 ||
              lastObd?.BF?.INJECT?.C2!== 0.0 ||
              lastObd?.BF?.INJECT?.C3!== 0.0 ||
              lastObd?.BF?.INJECT?.C4!== 0.0 ||
              lastObd?.BF?.RT!== 0.0 ||
              lastObd?.BF?.TT!== 0.0 ||
              lastObd?.BF?.TL!== 0.0 ||
              lastObd?.BF?.TP!== 0.0 ||
              lastObd?.BF?.RP!== 0.0 ||
              lastObd?.BF?.RGP !== 0.0) && (
              <CardEngineInfo title='گاز سوز'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.BF?.INJECT?.C1 !== undefined &&
                    lastObd?.BF?.INJECT?.C1!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش 1 </Typography>
                          <Typography>{lastObd?.BF?.INJECT?.C1}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Bifuel.Inject.Time1', 'زمان پاشش 1')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.BF?.INJECT?.C2 !== undefined &&
                    lastObd?.BF?.INJECT?.C2!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش 2 </Typography>
                          <Typography>{lastObd?.BF?.INJECT?.C2}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Bifuel.Inject.Time2', 'زمان پاشش 2')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}

                  {lastObd?.BF?.INJECT?.C3 !== undefined &&
                    lastObd?.BF?.INJECT?.C3!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش 3 </Typography>
                          <Typography>{lastObd?.BF?.INJECT?.C3}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Bifuel.Inject.Time3', 'زمان پاشش 3')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}

                  {lastObd?.BF?.INJECT?.C4 !== undefined &&
                    lastObd?.BF?.INJECT?.C4!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>زمان پاشش 4 </Typography>
                          <Typography>{lastObd?.BF?.INJECT?.C4}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Bifuel.Inject.Time4', 'زمان پاشش 4')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.BF?.RP !== undefined &&
                    lastObd?.BF?.RP!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>فشار ریل گاز </Typography>
                          <Typography>{lastObd?.BF?.RP}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Bifuel.RailPress', 'فشار ریل گاز')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}

                  {lastObd?.BF?.RT !== undefined &&
                    lastObd?.BF?.RT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>دمای ریل گاز </Typography>
                          <Typography>{lastObd?.BF?.RT}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Bifuel.RailTemp', 'دمای ریل گاز')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}

                  {lastObd?.BF?.RGP !== undefined &&
                    lastObd?.BF?.RGP!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>فشار رگولاتور </Typography>
                          <Typography>{lastObd?.BF?.RGP}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Bifuel.RegulatorPress', 'فشار رگولاتور')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}

                  {lastObd?.BF?.TL !== undefined &&
                    lastObd?.BF?.TL!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>سطح مخزن </Typography>
                          <Typography>{lastObd?.BF?.TL}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Bifuel.TankLevel', 'سطح مخزن')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  {lastObd?.BF?.TP !== undefined &&
                    lastObd?.BF?.TP!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>فشار مخزن </Typography>
                          <Typography>{lastObd?.BF?.TP}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Bifuel.TankPress', 'فشار مخزن')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}

                  {lastObd?.BF?.TT !== undefined &&
                    lastObd?.BF?.TT!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>دمای مخزن </Typography>
                          <Typography>{lastObd?.BF?.TT}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Bifuel.TankTemp', 'دمای مخزن')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
          {lastObd?.status !== undefined &&
            (lastObd?.status?.mask!== 0.0 || lastObd?.status?.value !== 0.0) && (
              <CardEngineInfo title='وضعیت'>
                <Box display='flex' flexDirection='column'>
                  {lastObd?.status?.mask !== undefined && lastObd?.status?.mask!== 0.0 && (
                    <Box display='flex' justifyContent='space-between'>
                      <Box
                        alignItems='center'
                        display='flex'
                        justifyContent='space-between'
                        width='200px'
                      >
                        <Typography>ماسک</Typography>
                        <Typography>{lastObd?.status?.mask}</Typography>
                      </Box>
                      <IconButton onClick={() => handleGeneral('Status.Mask', 'ماسک')}>
                        <TimelineIcon
                          sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                        />
                      </IconButton>
                    </Box>
                  )}
                  {lastObd?.status?.value !== undefined &&
                    lastObd?.status?.value!== 0.0 && (
                      <Box display='flex' justifyContent='space-between'>
                        <Box
                          alignItems='center'
                          display='flex'
                          justifyContent='space-between'
                          width='200px'
                        >
                          <Typography>وضعیت </Typography>
                          <Typography>{lastObd?.status?.value}</Typography>
                        </Box>
                        <IconButton onClick={() => handleGeneral('Status.Value', 'وضعیت')}>
                          <TimelineIcon
                            sx={{ backgroundColor: 'yellow', borderRadius: '50%', color: '#000' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                </Box>
              </CardEngineInfo>
            )}
        </div>
      </Box>
      <Dialog
        aria-describedby='alert-dialog-description'
        aria-labelledby='alert-dialog-title'
        onClose={handleClose}
        open={open}
        sx={{ direction: 'ltr' }}
      >
        <DialogTitle id='alert-dialog-title'>{t('screens.InfoEngineScreen.question')}</DialogTitle>
        <DialogContent>
          {/* <DialogContentText id='alert-dialog-description'>
            Let Google help apps determine location. This means sending anonymous location data to
            Google, even when no apps are running.
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t('screens.InfoEngineScreen.no')}</Button>
          <Button autoFocus onClick={handleDiag}>
            {t('screens.InfoEngineScreen.yes')}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  )
}

export default InfoEngineScreen
